module.exports = __webpack_public_path__ + "img/strategy-bg4.fbfc1a80.jpg";